import { useDispatch, useSelector } from "react-redux";
import styles from "./ReownForm.module.css";
import { sha256 } from "js-sha256";
import { useEffect, useState } from "react";
import UserService from "../../services/UserService";
import usePortalParam from "../../hooks/usePortalParam";
import { closeModal, setModalError } from "../../store/reducers/modalReducer";
import { selectAlert, clearSelectedAlerts } from "../../store/reducers/alertReducer";
import { selectSilenceRule, clearSelectedSilenceRules, setSilenceRules } from "../../store/reducers/silenceRulesReducer"
import AlertService from "../../services/AlertService";

const ReownForm = () => {
    const dispatch = useDispatch();
    const setPortalParam = usePortalParam()
    const selectedAlerts = useSelector(state => state.setAlertReducer.selectedAlerts)
    const selectedSilenceRules = useSelector(state => state.setSilenceRules.selectedSilenceRules)
    const [allUsers, setAllUsers] = useState([])
    const [selectedUser, setSelectedUser] = useState("")

    useEffect(() => {
        const usersRequest = async () => {
            try {
                const response = await UserService.getUsers()
                const users = response.data;
                const mappedUsers = users.map(user => ({
                    [user.name]: user.email,
                }));

                setAllUsers(mappedUsers);
            }
            catch (e) {
                dispatch(setModalError("Error during loading all users"))
                setPortalParam()
            }
        }
        usersRequest();
    }, [])

    const handleSelectUser = (userEmail) => {
        setSelectedUser((prev) => (prev === userEmail ? "" : userEmail));
    };

    const handleReownAlerts = async () => {
        console.log(selectedAlerts)
        try {
            if (selectedSilenceRules.length > 0) {
                const payload = {
                    "new_owner": selectedUser,
                    "sids_list": selectedSilenceRules
                }
                await AlertService.changeSilenceRulesOwner(payload)

                const res = await AlertService.getSileneced();
                dispatch(setSilenceRules(res.data));
                dispatch(clearSelectedSilenceRules())
            } else if (selectedAlerts.length > 0) {
                const payload = {
                    "new_owner": selectedUser,
                    "aids_list": selectedAlerts
                }
                await AlertService.changeAlertAckOwner(payload)
                dispatch(clearSelectedAlerts())
            }

        }
        catch (e) {
            dispatch(setModalError("Error during loading all users"))
            setPortalParam()
            return;
        } finally {
            setAllUsers([])
            setSelectedUser("")
            dispatch(closeModal())
        }

    }

    const isChangeDisabled = selectedUser === "";

    return (
        <div className={styles.formWindow}>
            <h1 className={styles.formTitle}>Change responsible user</h1>
            <ul className={styles.usersList}>
                {allUsers.map((user, index) => {
                    const key = Object.keys(user)[0];
                    const value = user[key];
                    const isSelected = selectedUser === value;

                    return (
                        <li key={index}>
                            <div className={`${styles.userEntry} ${isSelected ? styles.userEntrySelected : ""}`}
                                onClick={() => handleSelectUser(value)}
                            >
                                <img src={`https://gravatar.com/avatar/${sha256(value)}?s=150`} alt="user icon" className={styles.userIcon} />
                                <p className={styles.userName}>{key}</p>
                            </div>
                        </li>
                    );
                })}
            </ul>
            <button className={`${styles.changeButton} ${isChangeDisabled ? styles.changeButtonDisabled : styles.changedButtonActive}`}
                disabled={isChangeDisabled}
                onClick={e => {
                    e.preventDefault()
                    handleReownAlerts()
                }}
            >
                CHANGE
            </button>
        </div>
    )
}

export default ReownForm